import { render, staticRenderFns } from "./NotWorking.vue?vue&type=template&id=2eb97a90&scoped=true"
import script from "./NotWorking.vue?vue&type=script&lang=js"
export * from "./NotWorking.vue?vue&type=script&lang=js"
import style0 from "./NotWorking.vue?vue&type=style&index=0&id=2eb97a90&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb97a90",
  null
  
)

export default component.exports